// removed by extract-text-webpack-plugin
module.exports = {"Stage":"FestivalStage__Stage__2RqUx","StageContainer":"FestivalStage__StageContainer__36WYX"};